import { useState } from 'react'
import { ApiError } from '@akillidernek/api-client'
import { Button, Card, CardBody, CardHeader, Field, Input } from '@akillidernek/ui'
import { api } from '../api'
import { setAccessToken } from '../auth-store'

/**
 * Portal girişi — YES-159.
 *
 * Panelin giriş ekranından iki farkı var: ikinci adım (2FA) akışı yok — o
 * yöneticiye ait bir zorunluluk, üyeye değil — ve "hesabım yok" başvuru
 * formuna götürür, kayıt formuna değil. Portalda hesap açmanın tek yolu
 * başvurmaktır.
 */
export function Giris({ onBasvur }: { onBasvur: () => void }) {
  const [hata, setHata] = useState<string | null>(null)
  const [alanHatalari, setAlanHatalari] = useState<Record<string, string>>({})
  const [gonderiliyor, setGonderiliyor] = useState(false)

  async function gonder(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const form = new FormData(event.currentTarget)
    setGonderiliyor(true)
    setHata(null)
    setAlanHatalari({})
    try {
      const { data } = await api.POST('/api/v1/auth/login', {
        body: {
          email: String(form.get('email') ?? ''),
          password: String(form.get('password') ?? ''),
        },
      })
      if (!data) return
      if ('mfa_required' in data) {
        // Üyenin 2FA'sı varsa (panelde de yöneticiyse) portalda çözemeyiz.
        setHata('Hesabınızda ikinci adım doğrulama açık; yönetim panelinden giriş yapın.')
        return
      }
      setAccessToken(data.token.access_token)
    } catch (error) {
      if (error instanceof ApiError) {
        setHata(error.problem.detail)
        setAlanHatalari(error.fieldErrors())
      } else setHata('Beklenmeyen bir hata oluştu.')
    } finally {
      setGonderiliyor(false)
    }
  }

  return (
    <Card className="w-[min(26rem,100%)]">
      <CardHeader title="Giriş yap" description="Üyelik durumunuzu ve taleplerinizi görün." />
      <CardBody>
        <form onSubmit={gonder} className="flex flex-col gap-3">
          <Field label="E-posta" required error={alanHatalari.email}>
            {(props) => (
              <Input name="email" type="email" autoComplete="username" autoFocus {...props} />
            )}
          </Field>
          <Field label="Şifre" required error={alanHatalari.password}>
            {(props) => (
              <Input name="password" type="password" autoComplete="current-password" {...props} />
            )}
          </Field>
          {hata && (
            <p role="alert" className="text-xs text-[var(--ad-danger)]">
              {hata}
            </p>
          )}
          <Button type="submit" disabled={gonderiliyor}>
            {gonderiliyor ? 'Giriş yapılıyor…' : 'Giriş yap'}
          </Button>
          <Button type="button" variant="ghost" size="sm" onClick={onBasvur}>
            Hesabım yok, üyelik başvurusu yapmak istiyorum
          </Button>
        </form>
      </CardBody>
    </Card>
  )
}
